import { useTheme } from '../../../../../../hooks/useTheme';
import styles from '../Disco.module.css';

export function SponsoredPill() {
  const theme = useTheme();

  return (
    <div
      className={styles.sponsoredPill}
      style={{ fontFamily: theme.bodytextDefaultNone?.fontFamily }}
    >
      Sponsored
    </div>
  );
}
